// Single source of truth for public forms: the forms render from these and the dashboard reads answers from them.
export const WEDDING_FIELDS = [
  { key: "name", label: "Name", type: "text", required: true, testid: "wedding-name" },
  { key: "phone", label: "Phone", type: "tel", required: true, placeholder: "Best number to reach you", testid: "wedding-phone" },
  { key: "email", label: "Email", type: "email", required: true, testid: "wedding-email" },
  { key: "event_date", label: "Day of the party", type: "date", required: true, testid: "wedding-date" },
  { key: "tiers", label: "Interested in", type: "select", required: true, options: ["1 Tier", "2 Tier", "3 Tier", "4 Tier", "5 Tier", "6 Tier"], testid: "wedding-tiers" },
  { key: "flowers", label: "Do you want real or faux flowers on the cake?", type: "select", required: true, options: ["Real", "Faux", "No flowers"], testid: "wedding-flowers" },
  { key: "topper", label: "Topper? (ex. Mr & Mrs or Initials J & S)", type: "select", required: true, options: ["Yes", "No"], testid: "wedding-topper" },
  { key: "inspo_url", label: "Upload an inspo photo", type: "image", testid: "wedding-inspo-upload" },
  { key: "message", label: "Any questions or details?", type: "textarea", placeholder: "Tell me anything you'd like me to know", testid: "wedding-message" },
  { key: "preferred_contact", label: "What's your preferred way to get back to you?", type: "select", required: true, options: ["Email", "Text Message"], testid: "wedding-contact" },
];

export const CONTACT_FIELDS = [
  { key: "name", label: "Your name", type: "text", required: true, placeholder: "Your name", testid: "contact-name" },
  { key: "email", label: "Your email", type: "email", required: true, placeholder: "Your email (required)", testid: "contact-email-input" },
  { key: "phone", label: "Phone", type: "tel", placeholder: "Phone (optional)", testid: "contact-phone" },
  { key: "message", label: "Message", type: "textarea", required: true, placeholder: "How can I help?", testid: "contact-message" },
];

export const emptyValues = (fields) => Object.fromEntries(fields.map((f) => [f.key, ""]));

export const buildAnswers = (fields, values) =>
  fields.map((f) => ({ question: f.label, answer: String(values[f.key] ?? ""), kind: f.type === "image" ? "image" : f.type }));

const INTERNAL = new Set(["id", "type", "status", "created_at", "answers"]);
const humanize = (k) => k.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());

// Saved answers win; older submissions are mapped through the current form, and any extra stored fields are still shown.
export const submissionRows = (entry, fields) => {
  if (entry.answers?.length) return entry.answers;
  const known = fields.filter((f) => f.key in entry).map((f) => ({ question: f.label, answer: String(entry[f.key] ?? ""), kind: f.type === "image" ? "image" : f.type }));
  const extra = Object.keys(entry).filter((k) => !INTERNAL.has(k) && !fields.some((f) => f.key === k))
    .map((k) => ({ question: humanize(k), answer: String(entry[k] ?? ""), kind: "text" }));
  return [...known, ...extra];
};
